import React from "react";

type Props = {
  children?: React.ReactNode;
};

export function TableHeader(props: Props) {
  return <td className="table-header-column-name">{props.children}</td>;
}
